(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video-metayt"] && !Shopify.designMode) return;
  try {
    // Document-level delegation so handlers survive Horizon's editor
  // re-renders and work across multiple block instances.
  if (!window.__videoLightboxInit) {
    window.__videoLightboxInit = true;

    const embedUrl = (id) =>
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(id) +
      '?autoplay=1&rel=0&playsinline=1&enablejsapi=1';

    // Some browsers (Safari's sound policy in particular) ignore the
    // autoplay param inside a cross-origin iframe. Once the player
    // loads, nudge it with an explicit play command via the JS API.
    const nudgePlay = (iframe) => {
      iframe.addEventListener(
        'load',
        () => {
          const send = () => {
            try {
              iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":[]}', '*');
            } catch (e) {
              /* no-op */
            }
          };
          // The player needs a beat to boot before accepting commands
          setTimeout(send, 350);
          setTimeout(send, 1200);
        },
        { once: true }
      );
    };

    const getIframe = (dialog) => dialog.querySelector('[data-video-lightbox-iframe]');

    // --- Playlist player helpers ---

    const playCurrent = (player) => {
      const iframe = player.querySelector('[data-player-iframe]');
      if (!iframe || !player.dataset.videoId) return;
      player.classList.add('is-playing');
      nudgePlay(iframe);
      iframe.src = embedUrl(player.dataset.videoId);
    };

    const activateItem = (item) => {
      const gallery = item.closest('.video-gallery');
      const player = gallery && gallery.querySelector('[data-player]');
      if (!player) return;

      gallery.querySelectorAll('[data-playlist-item].is-active').forEach((el) => el.classList.remove('is-active'));
      item.classList.add('is-active');

      player.dataset.videoId = item.dataset.videoId;

      const title = player.querySelector('[data-player-title]');
      if (title) title.textContent = item.dataset.videoTitle || '';

      const meta = player.querySelector('[data-player-meta]');
      if (meta) meta.textContent = item.dataset.videoMeta || '';

      const iframe = player.querySelector('[data-player-iframe]');
      if (iframe) iframe.title = item.dataset.videoTitle || 'Video';

      const poster = player.querySelector('[data-player-poster]');
      if (poster) {
        poster.onload = () => {
          if (poster.naturalWidth <= 120 && item.dataset.videoFallback) {
            poster.onload = null;
            poster.src = item.dataset.videoFallback;
          }
        };
        poster.onerror = () => {
          poster.onerror = null;
          if (item.dataset.videoFallback) poster.src = item.dataset.videoFallback;
        };
        poster.src = item.dataset.videoPoster;
      }

      if (player.classList.contains('is-playing')) {
        playCurrent(player);
      }
    };

    // --- Delegated clicks ---

    document.addEventListener('click', (event) => {
      // Playlist: sidebar item selection
      const item = event.target.closest('[data-playlist-item]');
      if (item) {
        activateItem(item);
        return;
      }

      // Playlist: featured play button
      const playBtn = event.target.closest('[data-player-play]');
      if (playBtn) {
        playCurrent(playBtn.closest('[data-player]'));
        return;
      }

      // Lightbox: open
      const trigger = event.target.closest('[data-video-trigger]');
      if (trigger) {
        const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!dialog) return;

        const iframe = getIframe(dialog);
        iframe.title = trigger.dataset.videoTitle || 'Video';
        nudgePlay(iframe);
        iframe.src = embedUrl(trigger.dataset.videoId);

        dialog.showModal();
        return;
      }

      // Lightbox: close button
      const closeBtn = event.target.closest('[data-video-lightbox-close]');
      if (closeBtn) {
        closeBtn.closest('dialog')?.close();
        return;
      }

      // Lightbox: backdrop click — the dialog element itself is only
      // the click target when the click lands outside __inner.
      if (event.target instanceof HTMLDialogElement && event.target.hasAttribute('data-video-lightbox')) {
        event.target.close();
      }
    });

    // 'close' doesn't bubble, so listen in the capture phase.
    // Clearing src stops playback immediately (Esc key included).
    document.addEventListener(
      'close',
      (event) => {
        if (event.target instanceof HTMLDialogElement && event.target.hasAttribute('data-video-lightbox')) {
          const iframe = getIframe(event.target);
          if (iframe) iframe.src = '';
        }
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["videos-metaobject"] && !Shopify.designMode) return;
  try {
    // Document-level delegation so handlers survive Horizon's editor
  // re-renders and work across multiple block instances.
  if (!window.__videoLightboxInit) {
    window.__videoLightboxInit = true;

    const getIframe = (dialog) =>
      dialog.querySelector('[data-video-lightbox-iframe]');

    document.addEventListener('click', (event) => {
      // Open
      const trigger = event.target.closest('[data-video-trigger]');
      if (trigger) {
        const dialog = document.getElementById(
          trigger.getAttribute('aria-controls')
        );
        if (!dialog) return;

        const iframe = getIframe(dialog);
        iframe.title = trigger.dataset.videoTitle || 'Video';
        iframe.src =
          'https://www.youtube-nocookie.com/embed/' +
          encodeURIComponent(trigger.dataset.videoId) +
          '?autoplay=1&rel=0&playsinline=1';

        dialog.showModal();
        return;
      }

      // Close button
      const closeBtn = event.target.closest('[data-video-lightbox-close]');
      if (closeBtn) {
        closeBtn.closest('dialog')?.close();
        return;
      }

      // Backdrop click — the dialog element itself is only the click
      // target when the click lands outside __inner.
      if (
        event.target instanceof HTMLDialogElement &&
        event.target.hasAttribute('data-video-lightbox')
      ) {
        event.target.close();
      }
    });

    // 'close' doesn't bubble, so listen in the capture phase.
    // Clearing src stops playback immediately (Esc key included).
    document.addEventListener(
      'close',
      (event) => {
        if (
          event.target instanceof HTMLDialogElement &&
          event.target.hasAttribute('data-video-lightbox')
        ) {
          const iframe = getIframe(event.target);
          if (iframe) iframe.src = '';
        }
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

})();
